export const GET_BRANDS = "GET_BRANDS";
export const GET_BRANDS_LOADING = "GET_BRANDS_LOADING";
export const GET_FEATURED_BRANDS = "GET_FEATURED_BRANDS";
export const GET_FEATURED_BRANDS_LOADING = "GET_FEATURED_BRANDS_LOADING";
export const GET_BRAND_ITEMS = "GET_BRAND_ITEMS";
export const GET_BRAND_ITEMS_LOADING = "GET_BRAND_ITEMS_LOADING";
export const RESET_BRAND_ITEMS = "RESET_BRAND_ITEMS";
